import React from 'react';
import { Hero } from '../components/Hero';
import { EmotionalIntro } from '../components/EmotionalIntro';
import { ProblemSection } from '../components/ProblemSection';
import { WhyItFailed } from '../components/WhyItFailed';
import { SolutionSection } from '../components/SolutionSection';
import { PDFPreview } from '../components/PDFPreview';
import { IncludesSection } from '../components/IncludesSection';
import { ForYouSection } from '../components/ForYouSection';
import { HowItWorks } from '../components/HowItWorks';
import { FAQ } from '../components/FAQ';
import { PricingCTA } from '../components/PricingCTA';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen w-full bg-[#FAF8F5] overflow-x-hidden" data-id="element-148">
      <Hero data-id="element-149" />
      <EmotionalIntro data-id="element-150" />
      <ProblemSection data-id="element-151" />
      <WhyItFailed data-id="element-152" />
      <SolutionSection data-id="element-153" />
      <PDFPreview data-id="element-154" />
      <IncludesSection data-id="element-155" />
      <ForYouSection data-id="element-156" />
      <HowItWorks data-id="element-157" />
      <FAQ data-id="element-158" />
      <PricingCTA data-id="element-159" />
      <Footer data-id="element-160" />
    </div>;
}